import { Button, DatePicker, Drawer, Dropdown, Form, Input, Layout, Menu, message, Skeleton, Space, Spin, Typography } from 'antd';
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as CHALLENGES_SERVICES from "api/services/challenges/challenges.services";
import * as ROOMS_SERVICES from "api/services/rooms/rooms.services";
import * as TEACHER_SERVICES from "api/services/teacher/teacher.services";
import { resourcesClient } from 'common/axios.config';
import { FLAGS, removeDuplicates, StatusCode } from 'common/enums';
import AppResult from 'components/appResults';
import CercleChart from 'components/barChart/cercleChart';
import Breadcrumbs from 'components/breadcrumbs';
import ChallengeChart from 'components/challengeCharts';
import GroupClassesContent from 'components/classroomComponents/GroupClassesContent/GroupClassesContent';
import ClassroomHeader from 'components/classroomComponents/Header/Header';
import NavigationTabs from 'components/classroomComponents/NavigationTabs/NavigationTabs';
import ClassroomSidebar from 'components/classroomComponents/Sidebar/Sidebar';
import { TabType } from 'components/classroomComponents/types';
import AppButton from 'components/libs/button';
import Pagination from 'components/pagination';
import ParentOrganismAddRoom from 'components/parentOrganismAddRoom';
import { Moment } from 'moment';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { studentParser } from 'screens/student/RoomStudent/assets/utils/converters';
import DrawerAdsCreneauSpecific from 'screens/teacher/components/availabilitySpecific/drawer';
import DrawerPublications from 'screens/teacher/components/drawerPublications';
import AppScreen from 'screens/teacher/ScreenWithSidebar';
import { displayDrawerAdsSpecific } from 'store/adventissements';
import { setIsContributionUpdated, setNewInvitationSent } from 'store/app/appSlice';
import { setChatReceiverId, setSelectUserChat, toggleAppChat } from 'store/AppChat/appChat';
import { useFindRoomMutation } from 'store/services/chat';
import { handleClearTopicStrings, handleClearTopicStringsLength } from 'utils/formats';
import ArrowBack from "../../../assets/images/app/arrow_back.svg";
import StudentAvatar from "../../../assets/images/app/iam_student.svg";
import IconSearch, { ReactComponent as SearchIcon } from "../../../assets/images/app/search.svg";
import Teacher from "../../../assets/images/teacher/teacher.svg";
import IconTopic from '../teachers/components/iconTopic';
import TeacherCalendarForOrganism from './calendarTeacher';
import './ClassDetails.css';
import DrawerHistoriqueOrganism from './components/drawerHistoriqueOrganism';
import s from "./style.module.css";

const { Content } = Layout;
const { Title } = Typography;

const OrganismClassDetails: React.FC = () => {

  const { id } = useParams();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [activeTab, setActiveTab] = useState<TabType>('students');
  const [organismClass, setOrganismClass] = useState<any>();
  const { newInvitationSent } = useSelector((state) => state.app);
  const isContributionUpdated = useSelector((state) => state.app);
  const [loading, setLoading] = useState<boolean>(true);
  const [filteredStudents, setFilteredStudents] = useState<any>([]);
  const [studentsData, setStudentsData] = useState<any>([]);
  const [findRoom, { data: dataFindRoom, isSuccess }] = useFindRoomMutation();
  const [showAddClasse, setShowAddClasse] = useState<boolean>(false);
  const [showDrawerCreProf, setShowDrawerCreProf] = useState<boolean>(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isDrawerAttributionVisible, setIsDrawerAttributionVisible] = useState(false);
  const [openDrawerHistoriqueOrganism, setOpenDrawerHistoriqueOrganism] = useState<boolean>(false);
  const [openDrawerPublications, setOpenDrawerPublications] = useState(false);
  const [isDrawerChallengesHistoryVisible, setIsDrawerChallengesHistoryVisible] = useState(false);
  const [isDrawerChallengeDetailsVisible, setIsDrawerChallengeDetailsVisible] = useState(false);
  const [publicationData, setPublicationData] = useState<any>();
  const [challenges, setChallenges] = useState([]);
  const [challengesHistory, setChallengesHistory] = useState([]);
  const [filteredChallenges, setFilteredChallenges] = useState([]);
  const [challenge, setChallenge] = useState<any>();
  const [pieData, setPieData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [challengePieData, setChallengePieData] = useState<any>([]);
  const [challengeBarData, setChallengeBarData] = useState<any>([]);
  const [challengeStudentsData, setChallengeStudentsData] = useState<any>([]);
  const [challengePercentage, setChallengePercentage] = useState<any>();
  const [challengeDetailsPercentage, setChallengeDetailsPercentage] = useState<any>();
  const [quizWithAnswers, setQuizWithAnswers] = useState<any>([]);

  const [registredStudents, setRegistredStudents] = useState<any>();
  const [registredStudentsBigOne, setRegistredStudentsBigOne] = useState<any>();

  const [searchValue, setSearchValue] = useState("");
  const [challengeDetailsType, setChallengeDetailsType] = useState<string>("");

  const [currentPage, setcurrentPage] = useState<any>(1);
  const [selectedTeacher, setSelectedTeacher] = useState<any>(null);
  const [price, setPrice] = useState<any>();
  const [cost, setCost] = useState<any>();
  const [date, setDate] = useState<Moment | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingQuiz, setLoadingQuiz] = useState<boolean>(false);
  const [isFetchingChallengeData, setIsFetchingChallengeData] = useState<boolean>(false);
  const [teachersList, setTeachersList] = useState<any>([]);

  const [isCheckingFullCalendar, setIsCheckingFullCalendar] = useState<boolean>(false);

  const refSubmiteBtn = useRef<any>(null);
  const [page, setPage] = useState<any>(1);
  const [totalPages, setTotalPages] = useState<any>(1);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  const filterChallenges = (value: string) => {
    if (value !== undefined) {
      const filtered = value
        ? filteredChallenges.filter((challenge: any) =>
          challenge.title?.toLowerCase().includes(value.toLowerCase())
        )
        : challengesHistory;
      setFilteredChallenges(filtered);
    }
  }

  const handleReserve = () => {
    /// setShowDrawerCreProf(true);
    handleAddAvailability();
  };

  const handleSendMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: organismClass?.teacher?._id,
      flag: FLAGS.SINGLE_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(organismClass?.teacher?._id));
  };

  const handleSendCollectifMessage = () => {
    const findRoomBody = {
      actor1: user?._id,
      actor2: id,
      flag: FLAGS.GROUP_FLAG,
      instaprof: "",
      type: "",
    };

    findRoom(findRoomBody);
    dispatch(setChatReceiverId(id));
  };

  const fetchPublicationByClass = async (idClasse: string | undefined) => {
    try {
      const response = await ROOMS_SERVICES.fetchPublicationByClass(idClasse, page);
      if (response?.statusCode === StatusCode.OK) {
        setPublicationData(response?.data);
        dispatch(setIsContributionUpdated(false));
      }
    } catch (error: any) { }
  }

  const fetchClasse = useCallback(async (id: string | undefined) => {
    try {
      setLoading(true);
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setOrganismClass(response?.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const ReFetchClasse = useCallback(async () => {
    try {
      const response = await ROOMS_SERVICES.findOne(id);
      if (response?.statusCode === StatusCode.OK) {
        setOrganismClass(response?.data);
        setStudentsData(response?.data?.registeredStudents);
        setFilteredStudents(response?.data?.registeredStudents);
        dispatch(setNewInvitationSent(false));
      }
    } catch (error: any) {
      console.log(error);
    }
  }, [id]);

  const fetchChallengesByIdClass = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.findByIdClasse(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallenge(response?.data);
        }
      } catch (error: any) { }
    },
    []
  );

  const fetchChallengesHistory = useCallback(
    async () => {
      try {
        setIsFetchingChallengeData(true);
        const response = await CHALLENGES_SERVICES.fetchChallengesHistory(id);
        if (response?.statusCode === StatusCode.OK) {
          setChallengesHistory(response?.data);
          setFilteredChallenges(response?.data);
          setIsDrawerChallengesHistoryVisible(true);
        }
      } catch (error: any) { }
      finally {
        setIsFetchingChallengeData(false);
      }
    },
    [id]
  );

  const fetchPieStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getPieStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setPieData(response?.data);
      }
    } catch (error: any) { }
  }, []);

  const fetchBarStatsByIdClass = useCallback(async (id: string | undefined) => {
    try {
      const response = await CHALLENGES_SERVICES.getBarStatsByIdClasse(id);
      if (response?.statusCode === StatusCode.OK) {
        const data = response?.data;
        setBarData(
          data?.flatMap((e: any) => [
            { name: e.name, value: e.participation },
            { name: "Stat 2", value: 100 - e.participation }
          ])
        );
        setChallengePercentage(
          data?.flatMap((e: any) => {
            return e.participation
          })
        );
      }
    } catch (error: any) { }
  }, []);

  const handleChallengeStatsDisplay = (challenge: any) => {
    if (!challenge) {
      return;
    }
    const data = challenge?.participantsStats;
    setChallengeBarData(
      data?.flatMap((e: any) => [
        { name: e.name, value: e.participation },
        { name: "Stat 2", value: 100 - e.participation }
      ])
    );
    setChallengeDetailsPercentage(
      data?.flatMap((e: any) => {
        return e.participation
      })
    );
    setChallengePieData(challenge?.answersStats);
    setChallengeStudentsData(challenge?.ranking);
    setIsDrawerChallengeDetailsVisible(true);
  }

  const fetchClassementByChallenge = useCallback(
    async (id: string | undefined) => {
      try {
        const response = await CHALLENGES_SERVICES.fetchClassementByChallengee(
          id
        );
        if (response?.statusCode === 200) {
          setRegistredStudents(studentParser(response?.data));
          setRegistredStudentsBigOne(studentParser(response?.data));
        }
      } catch (error: any) { }
    },
    []
  );

  const getTeachers = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getAllTeachers(currentPage);
      if (res?.data) {
        setTeachersList(res?.data?.result);
        setTotalPages(res?.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const getTeacher = async () => {
    try {
      setIsLoading(true);
      setTeachersList([]);
      const res = await AUTH_SERVICES.getTeacher(currentPage, searchValue);
      if (res?.data) {
        setTeachersList(res?.data?.result);
        setTotalPages(res?.data?.totalPages);
      } else {
        throw new Error("Error");
      }
    } catch (error) { }
    finally {
      setIsLoading(false);
    }
  }

  const handleInviteStudent = () => {
    setShowAddClasse(true);
  }

  const handleAddTeacher = () => {
    setIsDrawerVisible(true);
  }

  // Open drawer with selected teacher details
  const handleButtonClick = (data: any) => {
    setSelectedTeacher(data);
    setIsDrawerAttributionVisible(true);
  };

  // Close the drawer
  const handleCloseDrawer = () => {
    setIsDrawerVisible(false);
  };

  const handleCloseAttributionDrawer = () => {
    setIsDrawerAttributionVisible(false);
    setSelectedTeacher(null);
    setPrice(null);
    setCost(null);
    setDate(null);
  };

  const handleSearchChange = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      const filterTeacher = teachersList.filter((item: any) =>
        item?.teacher.firstname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.lastname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item?.teacher.email.toLowerCase().includes(e.target.value.toLowerCase())
      );
      if (filterTeacher.length !== 0) {
        setTeachersList(filterTeacher);
      }
      else {
        console.log("here");
        setcurrentPage(1);
        getTeacher();
      }
    }
    else {
      getTeachers();
    }
  };

  const handleConfirmation = async () => {
    try {
      setLoading(true);

      const response = await TEACHER_SERVICES.addTeacherToClassroom(organismClass?._id, selectedTeacher?.prof?._id, price, Number(cost), date?.toISOString());

      if (response?.statusCode === StatusCode.CREATED) {
        message.success({
          content: "Prof ajouté avec succès.",
        });
        setSelectedTeacher(null);
        setPrice(null);
        setCost(null);
        setDate(null);
      } else {
        message.warning({
          content: "Erreur survenue lors de l'ajout du prof, merci de réessayer.",
        });
      }
    } catch (error) {
      message.warning({
        content: "Erreur survenue lors de l'ajout du prof, merci de réessayer.",
      });
    }
    finally {
      setLoading(false);
      setIsDrawerAttributionVisible(false);
      setIsDrawerVisible(false);
    }
  }

  const handleShowHistory = () => {
    setOpenDrawerHistoriqueOrganism(true);
  };

  const handleAddPublication = () => {
    setOpenDrawerPublications(true);
  };

  const handleSelectChallenge = (id: string) => {
    fetchPieStatsByIdClass(id);
    fetchBarStatsByIdClass(id);
    fetchClassementByChallenge(id);
  };

  const handleAddAvailability = () => {
    dispatch(displayDrawerAdsSpecific(true));
  };

  useEffect(() => {
    fetchClasse(id);
  }, [id]);

  useEffect(() => {
    if (newInvitationSent) {
      fetchClasse(id);
    }
  }, [newInvitationSent]);

  useEffect(() => {
    getTeachers();
  }, [user]);

  useEffect(() => {
    getTeachers();
  }, [currentPage]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess]);

  useEffect(() => {
    if (id) {
      fetchClasse(id);
      fetchChallengesByIdClass(id);
    }
  }, [id]);

  useEffect(() => {
    if (id && organismClass) {
      fetchPublicationByClass(id);
    }
  }, [id, organismClass]);

  useEffect(() => {
    if (id && organismClass && isContributionUpdated) {
      fetchPublicationByClass(id);
    }
  }, [id, organismClass, isContributionUpdated]);

  useEffect(() => {
    if (challenge) {
      fetchPieStatsByIdClass(challenge?._id);
      fetchBarStatsByIdClass(challenge?._id);
      fetchClassementByChallenge(challenge?._id);
    }
  }, [challenge]);

  useEffect(() => {
    if (quizWithAnswers?.length > 0) {
      setIsDrawerChallengeDetailsVisible(true);
    }
  }, [quizWithAnswers]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'students':
        return (
          !loading && <GroupClassesContent
            data={organismClass}
            students={filteredStudents}
            viewType="grid"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onNewAction={ReFetchClasse}
          />
        );
      case 'groupClasses':
        return (
          !loading && <GroupClassesContent
            data={organismClass}
            students={filteredStudents}
            viewType="calendar"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'publications':
        return (
          !loading && <GroupClassesContent
            data={organismClass}
            students={filteredStudents}
            viewType="publications"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
          />
        );
      case 'challenges':
        return (
          !loading && <GroupClassesContent
            data={organismClass}
            students={filteredStudents}
            viewType="challenges"
            publicationData={publicationData}
            onInviteStudent={handleInviteStudent}
            onShowHistory={handleShowHistory}
            onAddPublication={handleAddPublication}
            onSelectChallenge={handleSelectChallenge}
            pieData={pieData}
            barData={barData}
            challenges={challenges}
            challengePercentage={challengePercentage}
            challengeStudents={registredStudents}
            onDisplayChallengesHistory={fetchChallengesHistory}
            isFetchingChallengeData={isFetchingChallengeData}
          />
        );
      default:
        return null;
    }
  };

  const getQuizWithAnswers = async (idQuiz: string) => {
    setLoadingQuiz(true);
    try {
      const response = await resourcesClient.get(`/quizz/${idQuiz}/withInswers`,
        {
          headers: {
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
        }
      );
      if (response) {
        const data = response?.data;
        setQuizWithAnswers(data?.data?.questions);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoadingQuiz(false);
    }
  };

  const handleSeeChallengeDetails = (challenge: any) => {
    setChallengeDetailsType("dashboard");
    handleChallengeStatsDisplay(challenge);
  };

  const handleSeeChallengeQuiz = (challenge: any) => {
    setChallengeDetailsType("quiz");
    getQuizWithAnswers(challenge?.quizz?._id);
  };

  const handleSeeFullCalendar = () => {
    setIsCheckingFullCalendar(true);
    setShowDrawerCreProf(true);
  };

  const menu = (challenge: any) => (
    <Menu>
      <Menu.Item key="dashboard" onClick={() => handleSeeChallengeDetails(challenge)}>
        Dashboard
      </Menu.Item>

      <Menu.Item key="quiz" onClick={() => handleSeeChallengeQuiz(challenge)}>
        Quiz
      </Menu.Item>
    </Menu>
  );

  return (
    <React.Fragment>
      <div style={{ marginTop: "0px", marginBottom: "7em" }}>
        <Breadcrumbs isClassroom />
        <AppScreen>
          <div className="main">
            <div className="content">
              <ClassroomHeader data={organismClass} className={organismClass?.title} onReserve={handleReserve} />
              <div className="main-content">
                <NavigationTabs activeTab={activeTab} onChange={setActiveTab}>
                  {renderTabContent()}
                </NavigationTabs>
              </div>
            </div>

            <div className="sidebar">
              <ClassroomSidebar
                data={organismClass}
                challenge={challenge}
                onSendMessage={handleSendMessage}
                onSendCollectifMessage={handleSendCollectifMessage}
                onAddTeacher={handleAddTeacher}
                onSeeCalendar={handleSeeFullCalendar}
              />
            </div>
          </div>

          {/* Modal Ajout Classe */}
          {organismClass && <ParentOrganismAddRoom
            showAddClasse={showAddClasse}
            setShowAddClasse={setShowAddClasse}
            current={2}
            roomData={organismClass}
          />}

          {organismClass && !isCheckingFullCalendar && <TeacherCalendarForOrganism
            open={showDrawerCreProf}
            setOpen={setShowDrawerCreProf}
            currentTeacher={organismClass?.teacher}
            classroomId={organismClass?._id}
            onClose={() => setIsCheckingFullCalendar(false)}
          />}

          {/* Drawer Teachers */}
          <Drawer
            title={`Assigner un prof à cette classe`}
            placement="right"
            onClose={handleCloseDrawer}
            visible={isDrawerVisible}
            width={"70%"}
            style={{ zIndex: "2" }}
          >
            <div style={{ width: "100%" }}>
              <div>
                <Form
                  layout="inline"
                  name="searchTeacher"
                  autoComplete="off"
                  initialValues={{ search: searchValue }}
                  onFinish={getTeachers}
                >
                  <div className={s.filedSearch}>
                    <Form.Item name="search">
                      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                        <Input
                          type="text"
                          value={searchValue}
                          onChange={handleSearchChange}
                          style={{ border: "0px", marginLeft: "5px" }}
                          bordered={false}
                          placeholder="Trouver un prof"
                        />
                        <button
                          style={{ border: "unset", background: "transparent" }}
                        >
                          <SearchIcon
                            style={{
                              position: "relative",
                              width: "30px",
                              top: "3px",
                            }}
                          />
                        </button>
                      </div>
                    </Form.Item>
                    <Button
                      htmlType="submit"
                      ref={refSubmiteBtn}
                      style={{ display: "none" }}
                    >
                      Go
                    </Button>
                  </div>
                </Form>
              </div>

              <div style={{ marginTop: "20px", display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', overflowY: "scroll" }}>
                {isLoading ? (
                  <>
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                    <Skeleton active />
                  </>
                ) : teachersList.map((item: any, index: any) => {
                  return (item?.teacher?._id !== "62ceb218ce2dc5e1e1d9be89" && <div className={s.cardTeacher} key={index}>
                    <div style={{ height: "75px", width: "75px", background: "#FFF", borderRadius: "50%", alignItems: "center", justifyContent: "center" }}><img src={item?.teacher?.profile || Teacher} height={70} style={{ borderRadius: "50%" }}></img></div>
                    <div style={{ fontSize: "14px", color: "#000", textTransform: "uppercase", marginTop: "5px" }}>{item?.teacher?.lastname + " " + item?.teacher.firstname}</div>
                    <div style={{ fontSize: "12px", color: "#000", marginTop: "0px" }}>{item?.teacher?.nivMat[0]?.matieres[0]?.cost}€/heure</div>
                    {item?.teacher?.matieres.length > 0 && <div className={s.matiers}>
                      {handleClearTopicStrings(item?.teacher?.matieres)?.slice(0, 2).map((topic: any, idx: number) => (
                        topic ? (
                          <div className={s.course} key={idx}>
                            <IconTopic data={topic} />
                            <span>
                              {topic.includes("-")
                                ? topic.split("-")[0]
                                : topic === "Anglais"
                                  ? "Anglais"
                                  : topic === "Mathématiques"
                                    ? "Maths"
                                    : topic}
                            </span>
                          </div>
                        ) : null
                      ))} {handleClearTopicStringsLength(item?.teacher?.matieres) > 2 && "..."}
                    </div>}

                    <div className={s.levelGroup}>
                      {item?.teacher?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                        {removeDuplicates(item?.teacher?.groupLevels)?.slice(0, 2).map((level: any, index: number) => {
                          return (
                            level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                              <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                            </div>
                          );
                        })} {item?.teacher?.groupLevels?.length > 2 && "..."}
                      </div> : <span>Non renseigné</span>}
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", textTransform: "uppercase", fontSize: "10px", marginTop: "10px" }}>
                      {item?.prof?.langues?.includes("fr") && (
                        <>
                          <span style={{ marginRight: "3px" }}>Français</span>
                        </>
                      )}
                      {item?.prof?.langues?.includes("en") && (
                        <>
                          <span> - Anglais</span>
                        </>
                      )}
                    </div>
                    <div style={{ paddingLeft: "15%", paddingRight: "15%", marginTop: "20px", position: "absolute", bottom: "20px" }}>
                      <AppButton onClick={() => handleButtonClick(item)} style={{ margin: "0px", padding: "0px" }}>Assigner ce prof</AppButton>
                    </div>
                  </div>);
                })}
              </div>

              {!isLoading && teachersList?.length > 0 && (<div style={{ width: "100%", margin: "20px auto" }}>
                <Pagination
                  setCurrentPage={setcurrentPage}
                  totalPages={totalPages}
                  currentPage={currentPage}
                />
              </div>)}
            </div>
          </Drawer>

          {/* Drawer Attribution */}
          <Drawer
            title={`Attribution de prof à la classe`}
            placement="right"
            onClose={handleCloseAttributionDrawer}
            visible={isDrawerAttributionVisible}
            width={"30%"}
            style={{ zIndex: "2" }}
          >
            <div style={{ marginLeft: "10%", marginRight: "10%", }}>
              <div className={s.cardTeacher}>
                <div style={{ height: "75px", width: "75px", background: "#FFF", borderRadius: "50%", alignItems: "center", justifyContent: "center" }}><img src={selectedTeacher?.prof?.profile || Teacher} height={70} style={{ borderRadius: "50%" }}></img></div>
                <div style={{ fontSize: "14px", color: "#000", textTransform: "uppercase", marginTop: "5px" }}>{selectedTeacher?.prof?.lastname + " " + selectedTeacher?.prof.firstname}</div>
                {selectedTeacher?.prof && <div style={{ fontSize: "12px", color: "#000", marginTop: "0px" }}>{selectedTeacher?.prof?.nivMat[0]?.matieres[0]?.cost}€/heure</div>}
                {selectedTeacher?.prof?.matieres.length > 0 && <div className={s.matiers}>
                  {handleClearTopicStrings(selectedTeacher?.prof?.matieres)?.slice(0, 2).map((topic: any, idx: number) => (
                    topic ? (
                      <div className={s.course} key={idx}>
                        <IconTopic data={topic} />
                        <span>
                          {topic.includes("-")
                            ? topic.split("-")[0]
                            : topic === "Anglais"
                              ? "Anglais"
                              : topic === "Mathématiques"
                                ? "Maths"
                                : topic}
                        </span>
                      </div>
                    ) : null
                  ))} {handleClearTopicStringsLength(selectedTeacher?.prof?.matieres) > 2 && "..."}
                </div>}
                <div className={s.levelGroup}>
                  {selectedTeacher?.prof?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
                    {removeDuplicates(selectedTeacher?.prof?.groupLevels)?.slice(0, 2).map((level: any, index: number) => {
                      return (
                        level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                          <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                        </div>
                      );
                    })} {selectedTeacher?.prof?.groupLevels?.length > 2 && "..."}
                  </div> : <span>Non renseigné</span>}
                </div>
                <div style={{ display: "flex", flexDirection: "row", textTransform: "uppercase", fontSize: "10px", marginTop: "10px" }}>
                  {selectedTeacher?.prof?.langues?.includes("fr") && (
                    <>
                      <span style={{ marginRight: "3px" }}>Français</span>
                    </>
                  )}
                  {selectedTeacher?.prof?.langues?.includes("en") && (
                    <>
                      <span> - Anglais</span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div style={{ marginTop: '20px', marginLeft: "20%", marginRight: "20%", display: "flex", flexDirection: "column" }}>
              <p style={{ marginTop: "10px" }}><strong>Crédit à attribuer :</strong></p>
              <Input
                type="number"
                min={1}
                value={price}
                onChange={(e) => {
                  let value = e.target.value;

                  // Remove everything except digits
                  value = value.replace(/[^0-9]/g, "");

                  // Prevent 0 or empty
                  if (value === "" || Number(value) < 1) {
                    setPrice("");
                    return;
                  }

                  setPrice(value);
                }}
                placeholder="Entre le nombre de crédit"
                style={{ borderRadius: "8px", border: "1px solid #707070", color: "#000" }}
              />

              <p style={{ marginTop: "10px" }}><strong>Coût du crédit :</strong></p>
              <Input
                type="number"
                min={1}
                value={cost}
                onChange={(e) => setCost(e.target.value)}
                placeholder="Entre le coût du crédit"
                style={{ borderRadius: "8px", border: "1px solid #707070", color: "#000" }}
                suffix="€"
              />

              <p style={{ marginTop: "10px" }}><strong>Date d'expiration du crédit :</strong></p>
              <DatePicker
                value={date}
                onChange={(value) => setDate(value)}
                style={{ width: "100%" }}
              />

              {loading ? <Spin style={{ marginTop: "20px" }} /> : <Button onClick={handleConfirmation} style={{ marginTop: '20px', borderRadius: "20px", background: "#80b1b2", color: "#FFF", width: "50%", margin: "20px auto" }}>
                Confirmer
              </Button>}
            </div>
          </Drawer>

          {/* Drawer Attribution */}
          {organismClass && <DrawerHistoriqueOrganism
            open={openDrawerHistoriqueOrganism}
            setOpen={setOpenDrawerHistoriqueOrganism}
            classId={organismClass?._id}
            teacher={organismClass?.teacher}
            organismId={organismClass?.organism?._id}
          />}

          {/* Drawer Publications */}
          <DrawerPublications
            open={openDrawerPublications}
            currRoom={organismClass}
            setOpen={setOpenDrawerPublications}
            currLevel={organismClass?.level}
            onPublicationAdded={() => fetchPublicationByClass(id)}
          />

          {/* Drawer Historique des Challenges */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerChallengesHistoryVisible(false)}
            visible={isDrawerChallengesHistoryVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Historique des challenges
                <div className="search-box">
                  <Input
                    placeholder="Chercher ..."
                    onChange={(e) => filterChallenges(e.target.value)}
                    bordered={false}
                    suffix={<img src={IconSearch} height={15} />}
                  />
                </div>
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              {filteredChallenges.map((challenge: any) => (
                <div key={challenge?._id} className="challenge-row">
                  <div className="challenge-info">
                    <span className="challenge-title">
                      {challenge?.title}
                    </span>
                    <span className="challenge-date">
                      {new Date(challenge?.createdAt).toLocaleDateString("fr-FR", {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <Dropdown overlay={menu(challenge)} trigger={["click"]}>
                    <Button className="classBtn classBtn-teal" loading={loadingQuiz}>
                      Actions
                    </Button>
                  </Dropdown>
                </div>
              ))}
            </div>
          </Drawer>

          {/* Drawer Challenge Details */}
          <Drawer
            className="drawer"
            placement="right"
            onClose={() => setIsDrawerChallengeDetailsVisible(false)}
            visible={isDrawerChallengeDetailsVisible}
            width={isMobile ? "100%" : "65%"}
            title={
              <div style={{ fontSize: isMobile ? "0.8em" : "20px", fontFamily: "Poppins", fontWeight: "600", color: "#393E3E", backgroundColor: "transparent", display: "flex", flexDirection: "row", alignItems: "center", gap: "30px" }}>
                Détails du challenge
              </div>
            }
            headerStyle={{ border: "none", paddingTop: "50px", paddingLeft: isMobile ? "20px" : "40px", backgroundColor: "transparent" }}
            closeIcon={
              <img
                src={ArrowBack}
                height={isMobile ? 10 : 18}
                style={{}}
              ></img>
            }
            drawerStyle={{ backgroundColor: "#FFF", borderTopLeftRadius: isMobile ? "0px" : "50px", borderBottomLeftRadius: isMobile ? "0px" : "50px", boxShadow: "-3px 3px 34px #39393929" }}
            bodyStyle={{ zIndex: "1" }}
          >
            {challengeDetailsType === "dashboard" && <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              <div className="group-classes-content">
                <div className="content-header">
                  <Space className="content-header-title-box">
                    <Space className="content-header-title">
                      <Title level={4} style={{ margin: 0 }}>
                        Challenges stats
                      </Title>
                    </Space>
                  </Space>
                </div>

                <div style={{ padding: "10px 20px" }}>
                  {challengePieData && challengePieData.length === 0 ? <div
                    style={{
                      borderRadius: "15px",
                      padding: "0 5%",
                      width: "100%"
                    }}
                  >
                    <AppResult
                      status="info"
                      title={'Aucun challenge en cours !'}
                    />
                  </div> : challengeBarData && challengeBarData.length === 0 ? <div
                    style={{
                      borderRadius: "15px",
                      padding: "0 5%",
                      width: "100%"
                    }}
                  >
                    <AppResult
                      status="info"
                      title={'Aucune donnée reçu pour le moment !'}
                    />
                  </div> : <div className="graphe-left">
                    {/* update statistics dashboard */}

                    <div
                      style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      <div
                        style={{
                          width: "400px",
                          height: "300px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                        >
                          Taux de participation
                        </div>
                        {/* <CercleChart pieData={barData} /> */}
                        <ChallengeChart pieData={challengeBarData} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "30px",
                          }}
                        >
                          <div style={{ fontSize: isMobile ? "0.8em" : "14px" }}>Participation : {Number(challengeDetailsPercentage) % 1 === 0 ? Number(challengeDetailsPercentage).toFixed(0) : Number(challengeDetailsPercentage).toFixed(2)} %</div>
                        </div>
                      </div>
                      {challengePieData[0]?.total !== 0 && <div
                        style={{
                          width: "400px",
                          height: isMobile ? "auto" : "300px",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          fontFamily: "var(--body-font)",
                          marginTop: isMobile ? "20px" : "0px"
                        }}
                      >
                        <div
                          style={{ fontSize: isMobile ? "0.8em" : "14px" }}
                        >
                          Précision moyenne
                        </div>
                        <CercleChart pieData={challengePieData} />
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "30px",
                          }}
                        >
                          <div
                            style={{
                              color: "#80b1b2",
                              fontSize: isMobile ? "0.8em" : "14px",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "flex-start",
                              gap: "10px"
                            }}
                          >
                            Bonne réponse
                            <div style={{ height: "10px", width: "10px", background: "#80b1b2" }}></div>
                          </div>{" "}
                          <div style={{
                            color: "#80b1b2",
                            fontSize: isMobile ? "0.8em" : "14px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: "10px"
                          }}>
                            Mauvaise réponse
                            <div style={{ height: "10px", width: "10px", background: "#b0e0e1" }}></div>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </div>}
                </div>
              </div>

              {challengePieData && challengeBarData && challengeStudentsData && <div className="group-classes-content" style={{ marginTop: 10, paddingBottom: 20 }}>
                <div className="content-header">
                  <Space className="content-header-title-box">
                    <Space className="content-header-title">
                      <Title level={4} style={{ margin: 0 }}>
                        Élèves et classement
                      </Title>
                    </Space>
                  </Space>
                </div>

                {challengeStudentsData && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "90%", height: "auto", margin: "20px auto", paddingLeft: "20px", paddingRight: "20px" }}>
                  <div style={{ width: "45%" }}>
                    Élèves
                  </div>
                  <div style={{ width: "20%" }}>
                    Points
                  </div>
                  <div style={{ width: "20%" }}>
                    classement
                  </div>
                </div>}
                {challengeStudentsData && <div style={{ width: "90%", height: "1px", margin: "0px auto", background: "#C0C0C0", marginBottom: "20px" }}></div>}

                {challengeStudentsData ? challengeStudentsData?.map((student: any, index: number) => {
                  return (
                    <div className="user-challenge-row" key={index}>
                      {/* Left */}
                      <div className="user-info">
                        <img src={student?.profile || StudentAvatar} alt={student?.firstname} className="user-avatar" />
                        <span className="user-name">{student?.firstname + " " + student?.lastname}</span>
                      </div>

                      {/* Center */}
                      <div className="user-stats">
                        <span className="user-stat">{student?.points}</span>
                        <span className="user-stat">{student?.classement}</span>
                      </div>
                    </div>
                  );
                }) : <AppResult status={"info"} title={"Aucun participant."} />}
              </div>}
            </div>}

            {challengeDetailsType === "quiz" && <div style={{ marginLeft: "5%", marginRight: "5%", }}>
              <Title level={4} style={{ marginBottom: 20 }}>
                Quiz du challenge
              </Title>

              <div className="quiz-container">
                {quizWithAnswers?.map((question: any) => (
                  <div key={question._id} className="question-card">
                    {/* Question title */}
                    <div className="question-title">{question.title}</div>

                    {/* Propositions */}
                    <div className="propositions">
                      {question?.propositions?.map((prop: any) => (
                        <div
                          key={prop._id}
                          className="proposition"
                          style={{
                            border: `2px solid ${prop?.isCorrect ? "#2ecc71" : "#e74c3c"}`,
                          }}
                        >
                          {prop.title}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>}
          </Drawer>

          {/* Drawer Creneau Specific */}
          {organismClass?.teacher && <DrawerAdsCreneauSpecific
            isCollective={true}
            className={organismClass?.title}
            classeId={organismClass?._id}
            teacher={organismClass?.teacher}
            coursePrice={organismClass?.teacherCreditsCost}
          />}

          {isCheckingFullCalendar && <TeacherCalendarForOrganism
            open={showDrawerCreProf}
            setOpen={setShowDrawerCreProf}
            currentTeacher={organismClass?.teacher}
            onClose={() => setIsCheckingFullCalendar(false)}
            classroomId={organismClass?._id}
          />}
        </AppScreen>
      </div>
    </React.Fragment>
  );
};

export default OrganismClassDetails;